import styled from "@emotion/styled";
import React, { useEffect, useState } from "react";
import ModalVideo from "react-modal-video";
import PlayButton from "./play-circle-outline.svg";
import "../../../node_modules/react-modal-video/css/modal-video.min.css";
import { Link, useParams } from "react-router-dom";
import client from "../../graphql";
import { gql } from "@apollo/client";
import Spinner from "../Spinner/Spinner";

export default function MovieDetail() {
  const [isOpen, setOpen] = useState(false);
  const [videoId, setvideoId] = useState("");
  const { slug } = useParams();
  const [movie, setmovie] = useState(null);
  useEffect(() => {
    client
      .query({
        query: gql`
        query{
          movies(where :{slug :"${slug}"}){
            tmdb_id
            dubbed_movies{
              language
            }
          }
        }
        `,
      })
      .then(async (result) => {
        const id = result.data.movies[0].tmdb_id;
        let movie = await fetch(
          `https://api.themoviedb.org/3/movie/${id}?api_key=${process.env.REACT_APP_TMDB_KEY}&language=en-US`
        );
        movie = await movie.json();
        // setmovie(movie);
        let movie_videos = await fetch(
          `https://api.themoviedb.org/3/movie/${id}/videos?api_key=${process.env.REACT_APP_TMDB_KEY}&language=en-US`
        );
        movie_videos = await movie_videos.json();
        setmovie({
          ...movie,
          movie_videos,
          dubbed_movies: result.data.movies[0].dubbed_movies,
        });
      })
      .catch((err) => console.log(err));
    return () => {};
  }, [slug]);
  return (
    <>
      <ModalVideo
        channel="youtube"
        autoplay
        isOpen={isOpen}
        videoId={videoId}
        onClose={() => setOpen(false)}
      />
      {movie !== null ? (
        <>
          <Container
            bgImage={
              "//image.tmdb.org/t/p/w1920_and_h800_multi_faces" +
              movie.backdrop_path
            }
          >
            <Grid>
              <Poster>
                <img
                  src={
                    "//image.tmdb.org/t/p/w300_and_h450_bestv2" +
                    movie.poster_path
                  }
                  alt=""
                />
              </Poster>
              <MovieInfo>
                <p className="title">
                  {movie.original_title} &nbsp; (
                  <span>{movie.release_date.split("-")[0]}</span>)
                </p>
                <p className="metaInfo">
                  {movie.release_date.split("-")[2] +
                    "/" +
                    movie.release_date.split("-")[1] +
                    "/" +
                    movie.release_date.split("-")[0]}
                  &nbsp;.
                  {movie.genres.map((item, index) => {
                    if (index !== movie.genres.length - 1) {
                      return " " + item.name + ",";
                    }
                    return " " + item.name;
                  })}
                  &nbsp;. Rating : {movie.vote_average}/10
                </p>
                <p>
                  <i>{movie.tagline}</i>
                </p>
                <div
                  style={{
                    padding: "10px 0",
                    display: "flex",
                    flexWrap: "wrap",
                  }}
                >
                  <Link to={`/movies/${slug}/watch`} className={"watch-btn"}>
                    Watch Now
                  </Link>
                  {movie.dubbed_movies.length > 0 &&
                    movie.dubbed_movies.map((mov) => (
                      <Link
                        to={`/movies/${slug}/${mov.language}/watch`}
                        className={"watch-btn"}
                        key={slug}
                      >
                        Watch In {mov.language}
                      </Link>
                    ))}
                </div>
                <p>
                  <h2>Plot</h2>
                  <p style={{ textAlign: "left", fontSize: "120%" }}>
                    {movie.overview}
                  </p>
                </p>
              </MovieInfo>
            </Grid>
          </Container>
          <Container>
            <PaddedContainer>
              <h1>Videos</h1>

              <ScrollerWrapper>
                <Scroller>
                  {movie.movie_videos.results.map((vid) => {
                    return (
                      <VideoCard key={vid.key}>
                        <div style={{ position: "relative" }}>
                          <img
                            src={`https://i.ytimg.com/vi/${vid.key}/hqdefault.jpg`}
                            alt=""
                            width="100%"
                            style={{ zIndex: 5 }}
                          />
                          <Play
                            style={{
                              backgroundImage: "url(" + PlayButton + ")",
                            }}
                            onClick={() => {
                              setvideoId(vid.key);
                              setOpen(true);
                            }}
                          />
                        </div>
                      </VideoCard>
                    );
                  })}
                </Scroller>
              </ScrollerWrapper>
            </PaddedContainer>
          </Container>
        </>
      ) : (
        <div style={{flex : 0.95,display: "flex",alignItems : "center",justifyContent : "center"}}>
          <Spinner />
        </div>
      )}
    </>
  );
}

const Container = styled.div`
  max-width: 100vw;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: ${(props) => `url(${props.bgImage})`};
`;

const PaddedContainer = styled.div`
  padding: 20px 130px 20px 130px;
  @media (max-width: 877px) {
    padding: 20px 20px;
  }
`;

const Grid = styled.div`
  display: flex;
  padding: 20px 130px 20px 130px;
  background: ${(props) =>
    props.transparent ? "transparent" : "rgba(0, 0, 0, 0.6)"};
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
  backdrop-filter: blur(5.5px);
  -webkit-backdrop-filter: blur(5.5px);
  @media (max-width: 877px) {
    padding: 20px 20px;
  }
  @media (max-width: 768px) {
    flex-direction : column;
  }
`;

const Poster = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  & > img {
    @media (max-width: 768px) {
      width: 50vw;
    }
  }
`;

const MovieInfo = styled.div`
  color: white;
  padding: 20px 100px;
  flex: 3;
  @media (max-width: 768px) {
    padding: 10px;
  }
  .title {
    font-size: 240%;
  }

  .metaInfo {
    font-size: 120%;
  }

  .watch-btn {
    display: block;
    background-color: black;
    color: yellow;
    padding: 10px 20px;
    text-decoration: none;
    font-size: 110%;
    border-radius: 5px;
    margin-right: 5px;
    margin-top: 5px;
  }
`;

const ScrollerWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  margin: 20px auto;
`;

const Scroller = styled.ol`
  overflow-x: scroll;
  overflow-y: hidden;
  display: flex;
  width: 100%;
  list-style-type: none;
  list-style-position: inside;
  margin: 0;
  padding: 0;
  display: flex;
  position: relative;
  top: 0;
  left: 0;
  white-space: nowrap;
`;

const VideoCard = styled.li`
  width: 400px;
  white-space: nowrap;
  margin: 5px 10px;
  & > div {
    width: 400px;
    & > img {
      border-radius: 20px;
    }
    @media (max-width: 768px) {
      width: 82vw;
    }
  }
  @media (max-width: 768px) {
    width: 82vw;
  }
`;

const Play = styled.div`
  width: 70px;
  height: 70px;
  position: absolute;
  z-index: 10;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  transform-origin: 150% 150%;
  transition: transform 0.2s;
  &:hover {
    transform: scale(1.5);
  }
`;
